import { PROPERTY_DATA_REQUEST_API } from '../constants/AppConstants';
/**
 * Service to request property data
 * @param {string} completeAddress - The complete address for property data request
 * @returns {Promise} - API response promise
 */
const propertyDataRequestService = async (completeAddress) => {
  const requestBody = {
    address: {
      completeAddress,
    },
  };

  try {
    const response = await fetch(PROPERTY_DATA_REQUEST_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 202) return { ok: false, json, status: response.status };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default propertyDataRequestService;
